import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

export const CookiePolicy = () => {
  return (
    <div className="min-h-screen py-20 bg-gradient-to-br from-hr-warm-bg via-white to-hr-teal-light/10 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-hr-teal/5 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-hr-purple/5 rounded-full blur-3xl animate-float-slow" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <article className="bg-white rounded-2xl shadow-2xl p-8 lg:p-12 animate-fade-in-up">
          <header className="mb-12 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-hr-teal-light mb-6 animate-bounce-subtle">
              <Cookie className="h-8 w-8 text-hr-teal" />
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-hr-text-primary mb-4 animate-fade-in-up stagger-1" style={{ opacity: 0 }}>
              Cookie Policy
            </h1>
            <p className="text-hr-text-muted animate-fade-in-up stagger-2" style={{ opacity: 0 }}>Last Updated: 1/15/2026</p>
          </header>

          <div className="prose prose-lg max-w-none text-hr-text-secondary animate-fade-in-up stagger-3" style={{ opacity: 0 }}>
            <p className="lead">
              This Cookie Policy explains how HR Nest, LLC ("HR Nest," "we," "us," or "our") uses cookies and similar technologies when you visit our website.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">What Are Cookies?</h2>
            <p>
              Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you visit a website. They help the website remember your preferences and understand how you interact with the site.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">How We Use Cookies</h2>
            <p>We use cookies to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Improve your experience:</strong> Remember your preferences and settings</li>
              <li><strong>Analyze site traffic:</strong> Understand how visitors use our website</li>
              <li><strong>Support marketing efforts:</strong> Measure the effectiveness of our campaigns</li>
              <li><strong>Ensure security:</strong> Protect against fraud and unauthorized access</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Types of Cookies We Use</h2>

            <h3 className="font-heading text-xl font-semibold text-hr-text-primary mt-8 mb-3">Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function properly. They enable basic features like page navigation and access to secure areas.
            </p>

            <h3 className="font-heading text-xl font-semibold text-hr-text-primary mt-8 mb-3">Analytics Cookies</h3>
            <p>
              These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. We may use services like Google Analytics.
            </p>

            <h3 className="font-heading text-xl font-semibold text-hr-text-primary mt-8 mb-3">Functional Cookies</h3>
            <p>
              These cookies allow the website to remember choices you make (such as your preferred language or region) and provide enhanced, more personalized features.
            </p>

            <h3 className="font-heading text-xl font-semibold text-hr-text-primary mt-8 mb-3">Marketing Cookies</h3>
            <p>
              These cookies may be used to deliver advertisements more relevant to you and your interests. They may also be used to limit the number of times you see an advertisement.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Managing Cookies</h2>
            <p>
              You can manage your cookie preferences through your browser settings. Most browsers allow you to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>View what cookies are stored on your device</li>
              <li>Delete all or specific cookies</li>
              <li>Block cookies from specific or all websites</li>
              <li>Receive a warning before a cookie is stored</li>
            </ul>
            <p>
              Please note that blocking or deleting cookies may affect your experience on our website and limit some functionality.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Your Consent</h2>
            <p>
              By continuing to use our website, you consent to our use of cookies in accordance with this policy unless you disable them through your browser settings.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Changes to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Contact Us</h2>
            <p>
              If you have questions about our use of cookies, please contact us at:<br />
              📧 HRnestllc@gmail.com
            </p>

            <p className="mt-8">
              For more information about how we handle your personal data, please see our{' '}
              <Link to="/privacy" className="text-hr-purple hover:underline">Privacy Policy</Link>.
            </p>
          </div>
        </article>
      </div>
    </div>
  );
};

export default CookiePolicy;
